import { Component, inject, OnInit } from '@angular/core';
import { GERONIMO, getParamsGeronimoInSession } from '../../../../../../../../../../tools/utils/geronimo';
import { createUrlOsbProjects } from '../../../../../../../../../../tools/utils/url-osb';
import { environment } from '@core/envs';
import { ScheduleService } from '../../../../core/services/schedule/schedule.service';
import { StatusService } from '../../../../core/services/status/status.service';
import { SCHEDULE_STATUS } from '../../../../utils/schedule/constants/constants';
import { ScheduleStatusModel } from '../../../../core/models/schedule/scheduleStatus';
import { NotificationService } from '../../../../../../components/notification/services/notification.service';
import { TopBannerComponent } from '../../../../../../components/notification/top-banner/top-banner.component';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

import { CompactVerticalTrackerComponent } from '../../../../shared/components/compact-vertical-tracker/compact-vertical-tracker.component';
import { OpenScheduleComponent } from '../open-schedule/open-schedule.component';
import { StatusComponent } from '../status/status.component';
import { NgIf, NgClass } from '@angular/common';
import { isSourceFordPass, isSourcePerks } from '@core/utils';
import { NewScheduleService, SessionService } from '@agenda-customer-ui/data-access';
import { StorageKeys } from '@core/enums';
import { IOpenSchedule } from '@core/interface';
import { CountryRulesLibService } from '@core/services';
import { IUserProfileResponse } from '@core/interface';
import { ButtonLibComponent } from '@components/atoms';
import { SharedModuleLib } from '../../../../../../shared.module';

@Component({
  selector: 'agenda-customer-ui-status-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: true,
  imports: [
    TopBannerComponent,
    NgIf,
    NgClass,
    StatusComponent,
    OpenScheduleComponent,
    CompactVerticalTrackerComponent,
    SharedModuleLib,
    TranslateModule,
    ButtonLibComponent,
  ],
  providers: [ScheduleService, StatusService, NotificationService, TranslateService],
})
export class StatusDashboardComponent implements OnInit {
  newScheduleService = inject(NewScheduleService);
  readonly #countryService = inject(CountryRulesLibService);

  userProfile!: IUserProfileResponse;
  noSchedule = false;
  loading = true;

  // scheduledServices: ScheduledServicesModel[] = [];
  openSchedules!: IOpenSchedule[];
  scheduleStatusModels: any;
  status!: number;
  deliveryTracker: any;
  schedule: ScheduleStatusModel[] = [];
  vin = '';
  country = '';
  scheduleLenght = 0;
  scheduleStatus = 'no-content';

  isFordPass!: boolean;
  isPerks!: boolean;

  constructor(
    private scheduleService: ScheduleService,
    private notification: NotificationService,
    private translate: TranslateService,
    private sessionService: SessionService
  ) { }

  ngOnInit() {
    this.initialize();

    // Recuperando os regras do país
    this.#countryService.loadRules(this.country).subscribe();
  }

  initialize() {
    this.openSchedules = [];

    this.isFordPass = isSourceFordPass(this.sessionService.getItem(StorageKeys.SOURCE));
    this.isPerks = isSourcePerks(this.sessionService.getItem(StorageKeys.SOURCE));
    this.vin = this.sessionService.getItem(StorageKeys.VIN_ACTIVE_DASHBOARD);
    this.country = this.sessionService.getItem(StorageKeys.COUNTRY);
    this.getScheduledServicesStatusData();
  }

  getScheduledServicesStatusData() {
    this.status = SCHEDULE_STATUS.STATUS_IN_PROGRESS;
    this.newScheduleService
      .getScheduleStatusData(
        this.vin,
        this.country,
        this.status
      )
      .subscribe({
        next: (data) => {
          if (data && data.response && data.response.length > 0) {
            this.scheduleStatusModels = data.response;
            this.scheduleStatus = 'init';
            this.loading = false;
          } else {
            this.getScheduledServices();
          }
        },
        error: () => {
          this.getScheduledServices();
        },
      });
  }

  getScheduledServices() {
    this.newScheduleService.getOpened(this.vin).subscribe({
      next: (data) => {
        if (data.response && data.response.length) {
          this.openSchedules = data.response;
          this.scheduleStatus = 'opened';
        } else {
          this.scheduleStatus = 'no-content';
        }
        this.loading = false;
      },
      error: (error) => {
        this.scheduleStatus = 'no-content';
        const text =
          this.translate.instant('no-status.title') + ` ${error.status};`;
        this.notification.add({
          text: text,
          severity: 'ERROR',
          timeout: 4000,
        });
        this.loading = false;
      },
    });
  }

  reloadAfterCanceledSchedule() {
    this.loading = true;
    this.scheduleStatus = 'no-content';
    this.initialize();
  }

  goToSchedule() {
    this.scheduleService.goToSchedule();
  }

  redirectTo(project: string) {
    localStorage.setItem(
      'vin',
      sessionStorage.getItem(StorageKeys.VIN_ACTIVE_DASHBOARD) as string
    );

    let params = '';
    const geronimo = getParamsGeronimoInSession();

    if (geronimo.length) {
      const { country, dealerId } = JSON.parse(geronimo);
      params =
        country && dealerId
          ? `${GERONIMO}Country=${country}&${GERONIMO}DealerId=${dealerId}`
          : '';
    }

    if ('updateStorage' in sessionStorage) {
      sessionStorage.removeItem('updateStorage');
      params += 'updateStorage=true';
    }

    let url = '';
    if (project === 'osb') {
      url = environment.project.schedule;
    }

    const urlDefault = createUrlOsbProjects(
      url,
      params
    );

    window.location.assign(urlDefault);
  }
}
